import { FilterFunction, initAsyncSlice } from 'aa_common/front-end/zustand/init-async-slice'
import { FixedAssetsService, PresenterFixedAssetsActionStatusResp } from 'common/open-api'

const initFilters: { biids: string[] } = {
  biids: [],
}

const initState: PresenterFixedAssetsActionStatusResp = {}

let abortController: AbortController | null = null

const fetchData: FilterFunction<typeof initState, typeof initFilters> = async filters => {
  abortController?.abort()
  abortController = new AbortController()
  return FixedAssetsService.postFixedAssetsActionsStatus({ biids: filters?.biids }, { signal: abortController.signal })
}

export const assetListActionsStatusSlice = initAsyncSlice<typeof initState, typeof initFilters>(
  'fixed-asset/action-status',
  initState,
  initFilters,
  fetchData
)
